import * as React from "react";
import { useState, useEffect } from "react";
import { useUser } from "../../context/UserContext";
import { BASE_URL } from "../../utils/config"; 
import Toast from "../../utils/Toast"
import PackageName from "../../utils/accountPackages"
import moment from "moment";
import usePaginatedFilter from "../../hooks/usePaginatedFilters";
import PaginationControls from "../../utils/PaginationControls";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GroupsIcon from "@mui/icons-material/Groups";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import profile from "../../assets/imgs/passport.png";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Doughnut } from "react-chartjs-2";
import Modal from "@mui/material/Modal";
import { Chart, ArcElement } from "chart.js";
Chart.register(ArcElement);

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const columns = [
  { id: "stockist", label: "Stockist " },
  { id: "location", label: "Location" },
  { id: "email", label: "Email " },
  { id: "phone", label: "Phone " },
  { id: "registered", label: "Member Since" },
  { id: "status", label: "Status" },
];

const data = {
  datasets: [
    {
      data: [83, 20],

      backgroundColor: ["rgba(236, 112, 122, 1)", "rgba(16, 172, 126, 1)"],
    },
  ],
};

var config = {
  cutout: 28,
  responsive: true,
  maintainAspectRatio: true,
  options: {},
};

function createData(
  stockist,
  location,
  email,
  phone,
  status,
  registered,
) {
  return {
    stockist,
    location,
    email,
    phone,
    status,
    registered,
  };
}

const Stockist = () => {
  const [newStockistModal, setNewStockistModal] = useState(false);
  const [allAffiliates, setAllAffiliates] = useState([]);
  const [selectParent, setSelectParent] = useState("yes");
  const [allStockist, setAllStockist] = useState([]);
  const [toast, setToast] = useState(null);
  const [loading, setLoading] =useState(false);
  const handleModalClose = () => setNewStockistModal(false);
  const navigate = useNavigate();
  const { user } = useUser();
  const [error, setError] = useState("");

  // Filter Mechanism

  const STOCKIST_STATUSES = [
    { label: "Active", value: "1" },
    { label: "In-Active", value: "0" },
    { label: "Barred", value: "2" },
  ];

  const pagination = usePaginatedFilter({
    data: allStockist,
    searchKey: ["name", "email"],
    statusKey: "status",
    statusOptions: STOCKIST_STATUSES,
  });

  const {  paginatedData, currentPage, totalPages, pageSize, searchTerm, statusFilter, setCurrentPage, setPageSize, setSearchTerm, setStatusFilter } = pagination;


  const [formData, setFormData] = useState({
    affiliate_id: "",
      name: "",
      email: "",
      phone: "",
      address: "",
      country: "",
      state:  "",
      city : ""
  });

  const onChangeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const fetchStockists = () => {
    setLoading(true);
    fetch(`${BASE_URL}/stockists/fetchstockist`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Accept: "application/json",
            Authorization: "Bearer " + user?.token,
        },
    })
        .then((resp) => resp.json())
            .then((result) => {
				console.log(result);
                setAllStockist(result?.data || []);
            setLoading(false);
        })
        .catch((err) => {
            console.log(err);
            setLoading(false);
        });
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/stockists/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user?.token,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        setToast({ message: "Failed to register stockist!", type: "error" });
			  setTimeout(() => setToast(null), 7000);
        setLoading(false);
      }
      const result = await response.json();
      console.log(result);
      setToast({ message: `${result.message}`, type: "success" });
      setLoading(false);
      handleModalClose();
      
      setFormData({
        affiliate_id: "",
        name: "",
        email: "",
        phone: "",
        address: "",
        country: "",
        state:  "",
        city : ""
      });
			setTimeout(() => setToast(null), 9000);
      setToast({ message: "Stockist has been added successfully!", type: "success" });
      fetchStockists();
      // Make Payment
      // window.location.href = result?.data?.payment.authorization_url;
    } catch (error) {
      setLoading(false);
      setToast({ message: "Failed to register vendor!", type: "error" });
			setTimeout(() => setToast(null), 7000);
    }
  };


useEffect(()=> {
  fetchStockists();
},[])
  return (
    <section>
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      <section className="page__header">
        <div className="flex-container alc">
          <GroupsIcon />
          <h3>Manage Stockist</h3>
        </div>
      </section>
      <div className="s-divider"></div>
      <section style={{ display: "flex" }}>
        <div className="stat m-10">
          <div className="left__stat py-32">
            <div>
              <Doughnut data={data} options={config} className="w80" />
            </div>
            <h3 className="stat__value ml-10">
              {allStockist?.length}
              <p className="sub__title">Total Stockist</p> &nbsp;
            </h3>
          </div>
          <div className="right__stat">
            <div className="right__sub s-divider">
              <h3 className="stat__value c-success">83</h3>
              <p className="sub__title">Active</p>
            </div>
            <div className="right__sub">
              <h3 className="stat__value c-error">20</h3>
              <p className="sub__title">Inactive</p>
            </div>
          </div>
        </div>
      </section>

      <section className="flex-container alc p-y my-40">
        {/* Starts Here */}
        <div className="">
        <PaginationControls {...pagination} />
      </div>
      {/* Ends Here */}
        <div className="">
          <button
            className="btn btn-primary p-25"
            onClick={() => setNewStockistModal(true)}>
            Add Stockist
          </button>
        </div>
      </section>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="Stockist Table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData?.map((stock)=>(
            <TableRow onClick={() => navigate("details")} key={stock.id}>
              <TableCell className="b-r">
                <div className="d-flex alc f-10 flex-start">
                <div className={`user__avatar ${stock.acct_number !== null ? "bg-success" : "bg-error"}`}>
                    <h3 className="uppercase">
                      {stock.name[0]}</h3>
                  </div>
                  <div className="lheight13">
                    <h4 className="f-300">{stock.name}</h4>
                  </div>
                </div>
              </TableCell>
              <TableCell className="capitalize"> {stock.state ? stock.state : 'N/A'} ({stock.city ? stock.city : 'N/A'} )</TableCell>
              <TableCell> {stock.email}</TableCell>
              <TableCell> {stock.phone}</TableCell>
              <TableCell> {moment(stock.created_at).format("ll")} </TableCell>
              <TableCell>
                {" "}
                <span className={`badge ${stock.acct_number !== null ? "bg-success" : "bg-error"}`}>
                  {stock.acct_number !== null ? "Active" : "Inactive"}
                  </span>{" "}
              </TableCell>
            </TableRow>
            ))}
            
          </TableBody>
        </Table>
      </TableContainer>

      {/* Modal for stocks */}

      <Modal
        open={newStockistModal}
        onClose={handleModalClose}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return;
          handleModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Add Stockist</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal" style={{marginTop: 65}}>
            <div className="w-200">
              <div className="">
              </div>
            </div>
            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Stockist Center Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="name"
                    onChange={onChangeHandler}
                    value={formData.name}
                    placeholder="KYC Stockist Center"
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className=""> Affiliate Id</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="affiliate_id"
                    onChange={onChangeHandler}
                    value={formData.affiliate_id}
                    placeholder="e.g. PM-000000"
                  />
                </div>
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> email address</label>
                  <input
                    type="email"
                    className="form-control-input "
                    name="email"
                    onChange={onChangeHandler}
                    value={formData.email}
                    placeholder="email@domain.com"
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label> phone Number</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="phone"
                    onChange={onChangeHandler}
                    value={formData.phone}
                    placeholder="e.g. 0803 000 0000"
                  />
                </div>
                
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Stockist Location(Address)</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="address"
                    onChange={onChangeHandler}
                    value={formData.address}
                    placeholder="100 Main Street, ..."
                  />
                </div>
                
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Country</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="country"
                    onChange={onChangeHandler}
                    value={formData.country}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label> State</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="state"
                    onChange={onChangeHandler}
                    value={formData.state}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label> City</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="city"
                    onChange={onChangeHandler}
                    value={formData.city}
                  />
                </div>
                
              </section>
              

              {error && <p className="text-danger">{error}</p>}
              <div className="flex__normal pull-right mt-35">
          <button type="button" disabled={loading} className="btn btn-secondary p-25 pull-right mr-10"
          onClick={handleModalClose} >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary p-25 pull-right" disabled={loading}>
            {loading ? "Saving record..." : "Register Stockist"} 
          </button>
        </div>
            </form>
          </section>
        </Box>
      </Modal>
    </section>
  );
};

export default Stockist;
